<template>
  <div
    class="user_payment_transfer"
    :class="[list().length ? 'background' : '']"
  >
    <div v-show="loading" class="first-loading">
      <img src="../assets/loading.gif" />
    </div>
    <div v-if="!list().length && !loading" class="no-data">
      <img :src="NO_DATA.get(5).img" />
    </div>
    <div class="user_payment_transfer__list" v-else>
      <div
        v-for="(item, index) in list()"
        :key="index"
        @click="push(item.url)"
        class="list__item"
      >
        <p>{{ item.year }}年{{ item.month }}月</p>
        <img class="detail_icon" src="../assets/detail.svg" align="right" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProjectStore } from "../store/ProjectStore";
import { onMounted, ref } from "vue";
import { BASEURL } from "../consts/common";
import { NO_DATA } from "../consts/common";

const projectStore = ProjectStore();
document.title = "支払い通知書一覧";
const loading = ref(true);

onMounted(async () => {
  loading.value = true;
  if (!projectStore.userPaymentTransfers.length) {
    await projectStore.getUserPaymentTransfers();
  }
  loading.value = false;
});

// ページ遷移
function push(url: string) {
  window.open(BASEURL + url);
}

function list() {
  return projectStore.userPaymentTransfers;
}

// }
// })
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/_mixin.scss";
.user_payment_transfer {
  overflow-y: auto;
  width: 100%;
  max-width: 480px;
  height: 100%;
  // background: #eeeeee;
}
.background {
  background: #eeeeee;
}
.user_payment_transfer::-webkit-scrollbar {
  display: none;
}
.user_payment_transfer__list {
  width: 100%;
}
.list__item {
  @include menu-list-item();
}
.first-loading {
  display: flex;
  width: 96%;
  max-width: 460px;
  position: fixed;
  justify-content: center;
  top: 40%;
  img {
    width: 10%;
    height: 10%;
  }
}
</style>
